/**
 * Compares two object IDs the way the backend does: ignoring letter case. Graph, tokens and stored task rows don't
 * agree on the casing of a GUID, and a missing ID never equals anything.
 */
export function sameId(a: string | null | undefined, b: string | null | undefined): boolean {
  return !!a && !!b && a.toLowerCase() === b.toLowerCase();
}
